import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useActionCenterV2Data } from "../../hooks/useActionCenterV2Data";
import { P, usePermission } from "../../rbac";
import { BLACK_FRIDAY_OPEN_STATE_KEY } from "../../constants/blackFriday";
import { findBlackFridayCard } from "../../utils/blackFriday";
import BlackFridayStrip from "./BlackFridayStrip";

/**
 * The Black Friday strip for a page other than Home (Promotions, Figma
 * 1:24384). Its CTA goes Home and opens the card's Create Promo panel there,
 * where the card and its drawer live, so it needs the same permissions as
 * Home's own strip: Home view and Create Promo.
 */
const BlackFridayPageStrip = ({ selectedProperty }) => {
  const navigate = useNavigate();
  const { allowed: canViewHome } = usePermission(P.Home.View);
  const { allowed: canCreatePromo } = usePermission(
    P.Home.ActionCenter.CreatePromo
  );
  const { actionCenterV2Data } = useActionCenterV2Data(selectedProperty);
  const card = findBlackFridayCard(
    actionCenterV2Data,
    selectedProperty?.propertyId
  );

  if (!card || !canViewHome || !canCreatePromo) return null;

  return (
    <BlackFridayStrip
      card={card}
      onReview={() =>
        void navigate("/", {
          state: { [BLACK_FRIDAY_OPEN_STATE_KEY]: card.recommendationId },
        })
      }
    />
  );
};

BlackFridayPageStrip.propTypes = {
  selectedProperty: PropTypes.shape({
    propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};

export default BlackFridayPageStrip;
